import makeStyles from "@mui/styles/makeStyles";
import { MoreMenuProps } from "./MoreMenu";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: 48,
    minWidth: 48,
    padding: "0 !important",
    verticalAlign: "top !important",
  },
  wrap: (props: MoreMenuProps<any>) => ({
    position: "absolute",
    marginTop: 1,
    width: `calc(40px + ${theme.spacing(props.sidePadding || 0)})`,
    height: 42,
    right: 0,
    background: theme.palette.common.white,
  }),
  moreButton: {
    position: "absolute",
    inset: 0,
    width: 24,
    height: 24,
    margin: "auto",
    padding: 0,
    border: `1px solid ${theme.palette.grey[300]}`,
    background: theme.palette.common.white,
    borderRadius: 4,
    cursor: "pointer",
    "& svg": {
      width: 16,
      height: 16,
      color: theme.palette.grey[500],
    },
  },
}));
